<template>
    <el-form ref="information" :rules="rules" :model="information" label-width="120px" class="demo-ruleForm">
        <el-form-item label="项目名称" prop="name">
            <el-input v-model="information.name"></el-input>
        </el-form-item>
        <el-form-item label="项目简介(标语)" prop="intro">
            <el-input v-model="information.intro"></el-input>
        </el-form-item>
        <el-form-item label="项目介绍" prop="description">
            <el-input type="textarea" autosize v-model="information.description"></el-input>
        </el-form-item>
        <el-form-item label="照片墙">
            <el-upload multiple :http-request="uploadFile" action="" :on-remove="removeFile" :file-list="information.images" list-type="picture-card">
                <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
        </el-form-item>
        <el-form-item label="视频介绍VID" prop="video">
            <el-input v-model="information.video "></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary " @click="submitForm('information')">保存</el-button>
        </el-form-item>
    </el-form>
</template>
<script>
import AV from "leancloud-storage";
import Information from "../../model/information";

export default {


    data() {




        return {

            information: {

            },
            rules: {
                name: [
                    { required: true, message: "请输入项目名称", trigger: "blur" },
                    { min: 3, max: 60, message: "长度在 3 到 60 个字符", trigger: "blur" }
                ],
                intro: [
                    { required: true, message: "请输入项目简介(标语)", trigger: "blur" },
                    { min: 3, max: 30, message: "长度在 3 到 30 个字符", trigger: "blur" }
                ],
                description: [
                    { required: false, message: "请输入项目说明", trigger: "blur" },
                    { min: 0, max: 1000, message: "长度在 0 到 1000 个字符", trigger: "blur" }
                ]
            }
        }
    },

    created() {
        this.getData();

    },
    methods: {
        getData() {
            new AV.Query(Information).get('5b7cf6d0ee920a003d2c6b86').then(information => {
                console.log(information.toJSON());
                this.information = information.toJSON();


                // this.informationJSON = information.toJSON();

                if (this.information.images == undefined) {
                    this.information.images = [];
                }
            });

        },
        uploadFile(param) {
            let file = param.file;

            var fileAV = new AV.File(file.name, file);
            fileAV.save().then(f => {

                this.information.images.push({
                    name: file.name,
                    url: f.url()
                });

            }).catch(alert)

        },
        removeFile(file, fileList) {
            this.information.images.map((value, index, arr) => {
                if (file.url == value.url) {
                    this.information.images.splice(index, 1);

                }
            })

        },

        submitForm(formName) {


            this.$refs[formName].validate(valid => {

                if (valid) {


                    Object.assign(AV.Object.createWithoutData("Information", this.information.objectId), AV.parseJSON(this.information)).save().then(() => {
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                    }).catch(err => {
                        console.log(err);
                    });

                    　



                } else {
                    console.log("error submit!!");
                    return false;
                }
            });

        }
    }
}
</script>